import { createServerFn } from '@tanstack/react-start';
import _ from 'lodash';
import { z } from 'zod';

import { company_employees, company_investors } from '#/content';

/**
 * List company investors.
 * @returns The list of company investors.
 */
export const listCompanyInvestors = createServerFn({
  method: 'GET',
}).handler(async () => {
  return company_investors;
});

/**
 * List company founders.
 * @returns The list of company founders.
 */
export const listCompanyFounders = createServerFn({
  method: 'GET',
}).handler(async () => {
  return _.chain(company_employees)
    .filter((employee) => employee.founder)
    .value();
});

const getCompanyEmployeeSchema = z.object({
  id: z.string(),
});

/**
 * Get a company employee.
 *
 * @param data.id The ID of the company employee.
 * @returns The company employee.
 */
export const getCompanyEmployee = createServerFn({
  method: 'GET',
})
  .validator((payload: unknown) => getCompanyEmployeeSchema.parse(payload))
  .handler(async (ctx) => {
    const { id } = ctx.data;
    return getCompanyEmployeeSync(id);
  });

/**
 * Get a company employee synchronously.
 * @param id A company employee ID.
 * @returns A company employee.
 */
export const getCompanyEmployeeSync = (id: string) => {
  return _.find(company_employees, (employee) => employee.id === id) ?? null;
};
